module.exports = __webpack_public_path__ + "static/vortune_entire_page-2f2c6c146fc4bce114661be6d85f82dc.jpg";